// extracted by mini-css-extract-plugin
export default {"content":"BulkUnclaim_content__LnGyf"};